import http from './api'

const route = 'app/comercial/'

export default {
  showFaturamento: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showMeta: (dataInicio, dataFim, select, supervisor, tokenContrato, vendedores) => {
    return http.post(route + 'showMeta', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showFaturamentoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoBarrasFaturamentoxMeta: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, areas, classificacao) => {
    return http.post(route + 'showDadosGraficoBarrasFaturamentoxMeta', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      areas: areas,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoMetaMensal: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDadosGraficoMetaMensal', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoFaturamentoMesAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDadosGraficoFaturamentoMesAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoFaturamentoAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDadosGraficoFaturamentoAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showFaturamentoAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showFaturamentoAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoBarrasValorMonetario: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, areas, classificacao) => {
    return http.post(route + 'showDadosGraficoBarrasValorMonetario', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      areas: areas,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosGraficoBarrasValorMonetarioMetaDiario: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, areas, classificacao) => {
    return http.post(route + 'showDadosGraficoBarrasValorMonetarioMetaDiario', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      areas: areas,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showTendenciaFaturamento: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, areas, classificacao) => {
    return http.post(route + 'showTendenciaFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      areas: areas,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showValorMonetarioPedidosAbertos: (dataInicio, dataFim, select, receita, tokenContrato, supervisor, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showValorMonetarioPedidosAbertos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      receita: receita,
      tokenContrato: tokenContrato,
      supervisor: supervisor,
      vendedores: vendedores,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showValorTotalVolume: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, areas, classificacao) => {
    return http.post(route + 'showValorTotalVolume', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      areas: areas,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDiasFaturamento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDiasFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoImpropria: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDevolucaoImpropria', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucao: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDevolucao', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoMesAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDevolucaoMesAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },

  showDevolucaoAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor) => {
    return http.post(route + 'showDevolucaoAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      tokenContrato: tokenContrato,
    })
  },
}
